export default "__VITE_ASSET__D2r6Gitr__"